import { FC } from 'react';

import {
  HiddenBoxStyled,
  VerificationCodeFormFormErrors,
  VerificationCodeFormType,
} from 'components';
import { useTranslation } from 'libs/i18n';
import { Pressed, Stack, Typography } from 'libs/ui';
import { Icon } from 'libs/ui/Icon';
import { AuthView } from 'modules/auth/common/views/AuthView';

import { LoginForm, LoginFormProps } from '../components/LoginForm';
import { VerificationCodeForm } from '../components/VerificationCodeForm';

export interface LoginViewProps extends LoginFormProps {
  isTwoFactorAuthentication: boolean;
  onBackToLogin: () => void;
  onSubmitVerification: (values: VerificationCodeFormType) => {};
  verificationFormError?: VerificationCodeFormFormErrors;
}

export const LoginView: FC<LoginViewProps> = ({
  isTwoFactorAuthentication,
  onBackToLogin,
  onSubmitVerification,
  verificationFormError,
  ...formProps
}) => {
  const { t } = useTranslation();

  return (
    <AuthView>
      <>
        <HiddenBoxStyled hidden={isTwoFactorAuthentication}>
          <Stack spacing={24}>
            <Stack as="header" justifyContent="center">
              <Typography as="h1" variant="header">
                {t('auth.login.title')}
              </Typography>
            </Stack>

            <LoginForm {...formProps} />
          </Stack>
        </HiddenBoxStyled>

        {isTwoFactorAuthentication && (
          <Stack spacing={24}>
            <Pressed>
              <Stack
                alignItems="center"
                direction="row"
                spacing={4}
                onClick={onBackToLogin}
              >
                <Icon.Left size={16} />
                <Typography variant="captionMedium">
                  {t('common.back')}
                </Typography>
              </Stack>
            </Pressed>
            <Stack as="header" spacing={16}>
              <Typography as="h1" variant="header">
                {t('auth.login.twoFactorAuthentication.title')}
              </Typography>
              <Typography variant="bodyMedium">
                {t('auth.login.twoFactorAuthentication.subtitle')}
              </Typography>
            </Stack>
            <VerificationCodeForm
              initialErrors={verificationFormError}
              onSubmit={onSubmitVerification}
            />
          </Stack>
        )}
      </>
    </AuthView>
  );
};
